module.exports = __webpack_public_path__ + "img/log_2A_015.8f707063.png";